import { Auth } from 'aws-amplify';

const CLIENT_ID = process.env.VUE_APP_COGNITO_CLIENT_ID;
const APP_DOMAIN = process.env.VUE_APP_COGNITO_APP_DOMAIN;
const REDIRECT_URI = process.env.VUE_APP_COGNITO_REDIRECT_URI;
const USERPOOL_ID = process.env.VUE_APP_COGNITO_USERPOOL_ID;
const REDIRECT_URI_SIGNOUT = process.env.VUE_APP_COGNITO_REDIRECT_URI_SIGNOUT;
const VUE_API = process.env.VUE_APP_API_URL;

export default {
  Auth: {
    userPoolWebClientId: CLIENT_ID,
    userPoolId: USERPOOL_ID,
    oauth: {
      domain: APP_DOMAIN,
      scope: ['openid', 'email', 'profile', 'aws.cognito.signin.user.admin'],
      redirectSignIn: REDIRECT_URI,
      redirectSignOut: REDIRECT_URI_SIGNOUT,
      responseType: 'code',
    },
  },
  API: {
    endpoints: [
      {
        name: 'CDS-API',
        endpoint: VUE_API,
        custom_header: async() => {
          return {
            Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`,
          };
        },
      },
    ],
  },
};
